import React from 'react';
import { Star, User } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'Martín G.',
    age: 34,
    city: 'Córdoba',
    text: 'Soy mecánico y buscaba algo extra. Con el Mega Pack hice mi primera cochera en 3 semanas. Ya recuperé la inversión 5 veces.',
    role: 'Mecánico'
  }, {
    name: 'Lucas R.',
    age: 28,
    city: 'Rosario',
    text: 'Estaba sin trabajo y no sabía por dónde empezar. Seguí el sistema paso a paso y en un mes ya tenía mi primer cliente. Hoy hago 2-3 trabajos por semana.',
    role: 'Emprendedor'
  }, {
    name: 'Diego F.',
    age: 41,
    city: 'Buenos Aires',
    text: 'Trabajo en construcción hace 15 años. Agregar pisos epoxi fue la mejor decisión. Cobro el doble que antes por metro cuadrado.',
    role: 'Constructor'
  }, {
    name: 'Facundo M.',
    age: 31,
    city: 'Mendoza',
    text: 'No tenía experiencia en pisos. El programa me dio todo: qué comprar, cómo aplicar, cómo cotizar. En la cuarta semana ya estaba facturando.',
    role: 'Independiente'
  }, {
    name: 'Alejandro P.',
    age: 37,
    city: 'Tucumán',
    text: 'Arranqué de cero total. Hoy tengo clientes fijos que me recomiendan. El bono de conseguir clientes vale oro.',
    role: 'Aplicador'
  }];
  return <section className="py-16 px-4 bg-[#0a0a0a]" data-id="element-192">
      <div className="max-w-6xl mx-auto" data-id="element-193">
        <h2 className="text-3xl md:text-4xl font-black text-center mb-12 text-white" data-id="element-194">
          Lo que dicen quienes ya aplicaron el sistema
        </h2>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-195">
          {testimonials.map((t, i) => <div key={i} className="bg-[#141414] p-6 rounded-xl border border-gray-800 flex flex-col hover:border-amber-800/40 transition-colors" data-id="element-196">
              <div className="flex items-center gap-1 text-amber-500 mb-4" data-id="element-197">
                <Star className="fill-current w-4 h-4" data-id="element-198" />
                <Star className="fill-current w-4 h-4" data-id="element-199" />
                <Star className="fill-current w-4 h-4" data-id="element-200" />
                <Star className="fill-current w-4 h-4" data-id="element-201" />
                <Star className="fill-current w-4 h-4" data-id="element-202" />
              </div>

              <p className="text-gray-300 italic mb-6 flex-grow" data-id="element-203">"{t.text}"</p>

              <div className="flex items-center gap-3 mt-auto pt-4 border-t border-gray-800" data-id="element-204">
                <div className="w-10 h-10 bg-amber-900/40 rounded-full flex items-center justify-center text-amber-500" data-id="element-205">
                  <User className="w-6 h-6" data-id="element-206" />
                </div>
                <div data-id="element-207">
                  <p className="font-bold text-white" data-id="element-208">
                    {t.name}, {t.age}
                  </p>
                  <p className="text-sm text-gray-500" data-id="element-209">{t.city}</p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}